import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../../services/auth.services'
import { RestServices } from '../../../services/rest.services'
import { FormBuilder } from '@angular/forms'
import { SharedServices } from '../../../services/shared.services'
import { ModalService } from '../../../services/modal.service'

@Component({
    selector: 'app-modal-language',
    templateUrl: './modal-language.component.html',
    styleUrls: [
        '../../../stagingcss/root-ui-view.component.css',
        '../../../stagingcss/main-body.component.css',
        '../../../stagingcss/main-view.component.css',
        '../../../stagingcss/lui-select.component.css',
    ],
})

export class ModalLanguageComponent implements OnInit {

    ModalLanguge = 'hidden'
    filterLang: string
    showOption: any

    en = {}
    showEN = true

    langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    optionArr = [
        { id: 1, name: 'English', lang: 'true' },
        { id: 2, name: '日本語', lang: 'false' },
    ]
    optionArrCopy = this.optionArr.slice() // copy of optionArr
    styleVisibility: any


    constructor(private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private _sharedService: SharedServices,
                private modalService: ModalService) {
        this.modalService.changeEmitted$.subscribe(
            success => {
                if (success === 'selectLanguage') {
                    this.ModalLanguge = 'active'
                }
            })
    }

    // hiden modal
    hidenModalLanguge() {
        this.ModalLanguge = 'hidden'
    }

    changeLanguage() {
        const lang_default = localStorage.getItem('lang')
        if (lang_default === 'false') {
            this.showEN = false
            return this.en = this.authData.showLang(false)
        } else {
            this.showEN = true
            return this.en = this.authData.showLang(true)
        }
    }

    selectOption(id, lang) {
        this.showOption = 'showOption_' + id
        if (this.showOption || this.langDefault === lang) {
            this.authData.authToken().then(tokenReNew => {
                this.restApi.http_post('account/lang', { lang: id == 1 ? 'en' : 'ja' }, tokenReNew).subscribe(res => {
                    if(res['success']){
                        this.styleVisibility = { visibility: 'visible' }
                        localStorage.setItem('lang', lang)
                        this.langDefault = lang
                        this.changeLanguage()

                        this.hidenModalLanguge()
                        const emitChangeLanguege = {}
                        emitChangeLanguege['change'] = true
                        this._sharedService.emitChangeLanguage(emitChangeLanguege)
                    }
                })
            })
        }
    }

    // search language
    search(): void {
        const term = this.filterLang
        this.optionArr = this.optionArrCopy.filter(function(tag) {
            return tag.name.indexOf(term) >= 0
        })
    }

    ngOnInit() {
        if (this.langDefault) {
            this.styleVisibility = { visibility: 'visible' }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/language/modal-language.component.ts